import {Component, Input} from '@angular/core';

/**
 * handle search results and dispatch of those results in data display components
 */
@Component({
  selector: 'app-right-container',
  templateUrl: './right-container.component.html',
  styleUrls: ['./right-container.component.scss']
})

export class RightContainerComponent {
  @Input('displayUserManagement') displayUserManagement;

}
